import React from 'react';
import PropTypes from 'prop-types';
import {View, StyleSheet} from 'react-native';

import VideoContainer from 'components/Communication/VideoContainer';
import VideoFullscreenButton from '../VideoFullscreenButton';
import {getRemoteVideoObjectFit} from './remoteVideoUtils';

const RemoteVideo = ({
  remoteVideoConsumer,
  videoContainerStyle,
  isFocused,
  onToggleFocus,
}) => {
  let stream = null;
  if (
    remoteVideoConsumer &&
    remoteVideoConsumer.track &&
    remoteVideoConsumer.track.readyState === 'live'
  ) {
    // eslint-disable-next-line no-undef
    stream = new MediaStream();
    stream.addTrack(remoteVideoConsumer.track);
  }

  const waiting =
    remoteVideoConsumer &&
    (remoteVideoConsumer.locallyPaused || remoteVideoConsumer.remotelyPaused);

  const hide = !remoteVideoConsumer || waiting;
  const objectFit = getRemoteVideoObjectFit(remoteVideoConsumer);

  return (
    <View style={[styles.container, videoContainerStyle]}>
      <VideoContainer
        stream={stream}
        style={styles.video}
        waiting={waiting}
        hide={hide}
        objectFit={objectFit}
        zOrder={0}
      />
      {!hide && stream ? (
        <VideoFullscreenButton
          expanded={isFocused}
          onPress={onToggleFocus}
          testID={`remote-video-fullscreen-button-${remoteVideoConsumer.id}`}
        />
      ) : null}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    position: 'relative',
    backgroundColor: '#000000',
  },
  video: {
    width: '100%',
    height: '100%',
  },
});

RemoteVideo.defaultProps = {
  videoContainerStyle: {width: 200, height: 200},
  isFocused: false,
};

RemoteVideo.propTypes = {
  remoteVideoConsumer: PropTypes.shape({
    locallyPaused: PropTypes.bool,
    remotelyPaused: PropTypes.bool,
    id: PropTypes.string.isRequired,
    appData: PropTypes.shape({share: PropTypes.bool}),
    track: PropTypes.object,
  }).isRequired,
  videoContainerStyle: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.number,
    PropTypes.array,
  ]),
  isFocused: PropTypes.bool,
  onToggleFocus: PropTypes.func.isRequired,
};

export default React.memo(RemoteVideo);
